module.exports = __webpack_public_path__ + "img/lake001.06089a47.jpg";